import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f810f63a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f810f63a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f810f63a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f810f63a')) {
      api.createRecord('f810f63a', component.options)
    } else {
      api.reload('f810f63a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f810f63a&scoped=true", function () {
      api.rerender('f810f63a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P5_Activitys/Incentive/index.vue"
export default component.exports